<template>
	<div class="segment-bar">
		<div class="segment" @click.prevent="handleSelect(key)" v-for="(item, key) in segmentlist"   :class="{ on: key==selectedIndex }"><a>{{ item }}</a></div>
	</div>
</template>
<script>
  export default {
    name: "segmentBar",
    props: {
      segmentlist: {
        type: Array,
        default: function() {
          return []
        }
      },
      tabClick: {
        type: Function,
        default() {},
      },
      activeIndex: {
        type: Number,
        default: 0,
      },
    },
    watch: {
      activeIndex(val) {
        this.selectedIndex = val;
      },

    },
    data() {
      return {
        selectedIndex: 0,
        prevSelectedIndex: -1,
      };
    },
    methods: {
      handleSelect(index) {
        this.selectedIndex = index
        this.tabClick(index);

      }
    },
    mounted: function() {
	  //指定选中
	  this.handleSelect(this.activeIndex);


    $.fn.setSegWidth = function() {
      var maxWidth = 0;
      var $segmentBar = this
      var length = $segmentBar.children().length

      $segmentBar.children().each(function() {
        $(this).css('width', 'auto');
      })

      $segmentBar.children().each(function() {
        var itemWidth = $(this).outerWidth();
        if ($(this).hasClass('hover_ctr')) {
          itemWidth = itemWidth;
        }
        if ($(this).hasClass('more')) itemWidth = itemWidth;
        if(itemWidth>maxWidth) {
          maxWidth=itemWidth
        }
      });
      maxWidth = maxWidth;
      var num = $segmentBar.children().length;

      $segmentBar.children().each(function() {
        $(this).css('width', maxWidth);
      });
      $segmentBar.css('width', maxWidth*length)
    }
    $('.segment-bar').setSegWidth()
  }
};
</script>



// WEBPACK FOOTER //
// src/components/segmentBar/segmentBar.vue